import Datagent from "datagent";
import {respondData,requestHandle,List,isDef} from "../utils";
import { getURL } from 'datagent/src/utils';

const isNew = data => !isDef(data.id) || !data.id
const {filter, format, getField, awaitTo} = Datagent.Hooks;

import Fecha from '../utils/type/Fecha';
import {defaults} from "datagent/src/utils";

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name = "carbonTarget";
const Model = Datagent.Model({
    name,
    fields: {
        'id'                 : {type: Number, default: null},
        'firstTargetName'    : {type: String, default:''}, //一级指标
        'firstTargetNum'     : {type: String, default: ''}, // 一级指标编码
        'secondTargetName'   : { type: String, default: ''}, //二级指标
        'secondTargetNum'    : {type: String, default: ''}, // 二级指标编码
        'thirdTargetName'    : { type: String, default: ''}, //三级指标
        'thirdTargetNum'     : {type: String, default: ''}, // 三级指标编码
        // 'industryIdList'     : {type: List(Number), default: []}, // 行业ID列表
        'industryId'         : {type: Number, default: null}, // 行业ID列表
        'year'               : {type: Number, default: null}, //年份
        'keyword'            : {type: String, default: ''}, //关键词
        'targetType'         : {type: Number, default: 0}, //指标类型0-定量；1-定性
        'targetRuleExplain'  : {type: String, default: ''}, //指标规则说明
        'targetWeight'       : {type: parseFloat, default: null}, //指标权重
        'targetUnit'         : {type: String, default: ''}, //指标单位
        'targetSource'       : {type: Number, default: 0}, //指标来源：0-年报；1-社报；2-舆情
        'classification'     : {type: Number, default: 0}, //指标分类：0-共有指标；1-行业指标
    },
    methods: {
        fetch(params, opts){
            const { origin } = defaults(opts);
            const { type, ...query } = params
            // const url = type == 'listed' ? `listedTarget/list` : `${this._url}/list`
            return this.remote(origin).get(`${this._url}/list`, { ...query });
        },
        SaveKeyword(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params
            // const url = type == 'listed' ? `${type}Target/keyword` : '/target/keyword'
            return this.remote(origin).put(`${this._url}/keyword`, { ...query });
        },
        sentiment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/sentiment`,params)
        },
        firstTarget(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params
            // const url = type == 'listed' ? `${type}Target/firstTarget` : `/target/firstTarget`
            return this.remote(origin).get(`${this._url}/firstTarget`, query)
        },
        secondTarget(params, opts) {
            const { origin } = defaults(opts);
            const { type, ...query } = params
            // const url = type == 'listed' ? `${type}Target/secondTarget` : `/target/secondTarget`
            return this.remote(origin).get(`${this._url}/secondTarget`, query)
        },
        thirdTarget(params, opts) {
            const { origin } = defaults(opts);
            // const { type, ...query } = params
            // const url = type == 'listed' ? `${type}Target/thirdTarget` : `/target/thirdTarget`
            return this.remote(origin).get(`${this._url}/thirdTarget`, params)
        },
        save(detail, opts) {
            const { origin } = defaults(opts);
            const { data, action } = detail
            const { thirdTargetNum, type } = data;
            // const url = getURL(type == 'listed' ? `listedTarget/list` : this._url, secondTargetNum, this._emulateIdKey);
            const url = getURL(this._url, thirdTargetNum, this._emulateIdKey);
            console.log(type, url, data,action)
            return this.remote(origin)[isNew(data) || action == 'baseEdit' ? 'post' : 'put'](url, data);
        },
        historyTarget(params, opts) {
            const { origin } = defaults(opts);
            const { limit = 999, type, ...query } = params
            // const url = type == 'listed' ? `listedTarget/historyTarget` : `${this._url}/historyTarget`
            return this.remote(origin).get(`${this._url}/historyTarget`, { ...query, limit });
        },
        destroy(params, opts) {
            const { origin } = defaults(opts);
            const { year, industryId, thirdTargetNum, type } = params
            if(!isDef(year)) throw new Error("指标删除必须传入年份")
            if(!isDef(industryId)) throw new Error("指标删除必须传入行业ID")
            if(!isDef(thirdTargetNum)) throw new Error("指标删除必须传入三级指标编号")
            // const url = type == 'listed' ? `listedTarget/list` : this._url
            return this.remote(origin).delete(this._url, { ...params });
        },
        export(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/list/export`, params)
        },
        targetRuleExplain(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/targetRuleExplain`,params)
        }
    },
    hooks: {
        ...Datagent.mapSendHook([format()]),
        fetch: { after: [respondData(), requestHandle(), getField("data", format())] },
        find: { after: [respondData(), requestHandle(), format()] },
        sentiment: { after: [respondData(), requestHandle(), getField('data', format())] },
        firstTarget: { after: [respondData(), requestHandle(), getField('data', format())] },
        secondTarget: { after: [respondData(), requestHandle(), getField('data', format())] },
        thirdTarget: { after: [respondData(), requestHandle(), getField('data', format())] },
        historyTarget: { after: [respondData(), requestHandle()] },
        export: { after: [respondData(), requestHandle()] },
        targetRuleExplain: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
Model.validation = function () {
    return {
      firstTargetNum: [
        { required: true, type: 'string', message: '请选择一级指标', trigger: 'change' }
      ],
      secondTargetName: [
        { required: true, type: 'string', message: '请输入指标名称', trigger: 'change' }
      ],
      // industryIdList: [
      //   { required: true, type: 'array', message: '请选择所属行业', trigger: 'change' }
      // ],
      year: [
        { required: true, type: 'number', message: '请选择年份', trigger: 'change' }
      ],
      targetType: [
        { required: true, type: 'number', message: '请选择指标类型', trigger: 'change' }
      ],
      targetWeight: [
        { required: true, type: 'number', message: '请输入指标权重', trigger: 'change' }
      ],
      targetSource: [
        { required: true, type: 'number', message: '请选择指标来源', trigger: 'change' }
      ],
      classification: [
        { required: true, type: 'number', message: '请选择指标分类', trigger: 'change' }
      ],
      industryId: [
        { required: true, type: 'number', message: '请选择所属行业', trigger: 'change' }
      ],
    }
};
export default Model;
